(() => {
    if (window.__monadasCardSizes) return;
    window.__monadasCardSizes = true;

    const render = (holder, color) => {
      const data = holder._mcsData;
      if (!data) return;
      const sIdx = Number(holder.dataset.sizeIndex);
      const cIdx = Number(holder.dataset.colorIndex);
      const sizes = [];
      data.forEach(([available, options]) => {
        if (!available) return;
        if (cIdx > -1 && color != null && options[cIdx] !== color) return;
        const s = options[sIdx];
        if (s && !sizes.includes(s)) sizes.push(s);
      });
      const strip = holder._mcsStrip;
      strip.textContent = '';
      sizes.forEach((s) => { const el = document.createElement('span'); el.textContent = s; strip.appendChild(el); });
      if (!sizes.length) strip.textContent = 'Agotado';
      strip.classList.toggle('is-empty', !sizes.length);
      const inline = holder.querySelector('[data-mcs-inline]');
      if (inline) inline.textContent = sizes.length ? sizes.join('  ·  ') : 'Agotado';
      requestAnimationFrame(() => { const card = holder.closest('product-card'); if (card) card.style.setProperty('--mcs-h', strip.offsetHeight + 'px'); });
    };

    const selectedColor = (card, holder) => {
      if (Number(holder.dataset.colorIndex) < 0) return null;
      const checked = card.querySelector('product-swatches input[type="radio"]:checked');
      return checked ? checked.value : null;
    };

    const init = (holder) => {
      if (holder._mcsReady) return;
      const card = holder.closest('product-card');
      const gallery = card && card.querySelector('.card-gallery');
      const json = holder.querySelector('[data-mcs-json]');
      if (!card || !gallery || !json) return;
      try { holder._mcsData = JSON.parse(json.textContent); } catch (e) { return; }
      holder._mcsReady = true;
      const strip = document.createElement('div');
      strip.className = 'mcs__strip';
      strip.setAttribute('aria-hidden', 'true');
      gallery.appendChild(strip);
      holder._mcsStrip = strip;
      render(holder, selectedColor(card, holder));

      card.addEventListener('change', (event) => {
        if (event.target.matches('product-swatches input[type="radio"]')) render(holder, event.target.value);
      });
      card.addEventListener('pointerover', (event) => {
        const label = event.target.closest && event.target.closest('product-swatches label');
        const input = label && label.querySelector('input[type="radio"]');
        if (input) render(holder, input.value);
      });
      card.addEventListener('pointerleave', () => render(holder, selectedColor(card, holder)));
    };

    const moveBadge = (badge) => { if (badge._mcbDone) return; const card = badge.closest('product-card'); const gallery = card && card.querySelector('.card-gallery'); if (!gallery) return; badge._mcbDone = true; gallery.appendChild(badge); };
    const scan = (root) => { (root || document).querySelectorAll('[data-mcs]').forEach(init); (root || document).querySelectorAll('[data-mcb]').forEach(moveBadge); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan()); else scan();
    new MutationObserver((records) => {
      for (const r of records) for (const n of r.addedNodes) if (n.nodeType === 1) { if (n.matches && n.matches('[data-mcs]')) init(n); else if (n.matches && n.matches('[data-mcb]')) moveBadge(n); else if (n.querySelectorAll) scan(n); }
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();